/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Dispatch_FailedInputs */

const en_conversion_error_dispatch_failed = /** @type {(inputs: Conversion_Error_Dispatch_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your document could not be queued for conversion. Please try again.`)
};

const es_conversion_error_dispatch_failed = /** @type {(inputs: Conversion_Error_Dispatch_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo poner tu documento en cola para su conversión. Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Your document could not be queued for conversion. Please try again." |
*
* @param {Conversion_Error_Dispatch_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_dispatch_failed = /** @type {((inputs?: Conversion_Error_Dispatch_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Dispatch_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_dispatch_failed(inputs)
	return en_conversion_error_dispatch_failed(inputs)
});